<main id="main" class="error-403">

  <header class="ba-content-header ba-with-overlay ba-with-image">
    <div class="ba-header-image"><img class="img403" src="errors/error403.svg" alt=""></div>
    <div class="ba-content-wrap">
      <div class="ba-overlay">
        <h1>{{ "error.http.403.title" | i18next }}</h1>
      </div>
    </div>
  </header>

  <div class="container-fluid ba-copytext">
    <p>{{ "error.http.403.description" | i18next }}</p>
  </div>
  <div class="container-fluid ba-copytext">
    <h2>{{ "error.http.403.causes.title" | i18next }}</h2>
    <ul>
      <li>{{ "error.http.403.causes.cause-login" | i18next }}</li>
      <li>{{ "error.http.403.causes.cause-session" | i18next }}</li>
      <li>{{ "error.http.403.causes.cause-permission" | i18next }}</li>
      <li>{{ "error.http.403.causes.cause-changed-permission" | i18next }}</li>
      <li>{{ "error.http.403.causes.cause-deleted" | i18next }}</li>
    </ul>
    <a href="#" class="ba-btn ba-btn-primary">
        {{ "error.http.403.actions.login" | i18next }}
    </a>
    <a href="https://www.arbeitsagentur.de/" class="ba-btn ba-btn-secondary">
        {{ "error.http.403.actions.back-to-home" | i18next }}
    </a>
  </div>
</main>
